export enum EDataBaseType {
  MSSQL = 1,
  Oracle = 2
}
